import { inject, Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { switchMap, take, tap } from 'rxjs/operators'
import { unauthorizedError } from '@core/store/actions/error.actions'
import { Store } from '@ngrx/store'
import { signOut } from '@core/store/actions/auth.actions'
import { CoreAuthService } from '@core/auth/services/core-auth-service'
import { Platform } from '@ionic/angular'
import { environment } from '@env'

@Injectable()
export class ErrorEffects {
  private readonly _store: Store = inject(Store)
  private readonly _actions$: Actions = inject(Actions)
  private readonly _platform: Platform = inject(Platform)
  private readonly _ionicAuth: CoreAuthService = inject(CoreAuthService)

  unauthorizedError$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(unauthorizedError),
        switchMap(() => this._ionicAuth.token$.pipe(take(1))),
        tap((tokenResponse) => {
          if (tokenResponse?.isValid(0)) {
            const IDENTITY = environment.identityServerConfig(this._platform.is('capacitor'))
            this._store.dispatch(signOut(IDENTITY.endSessionRedirectConcurrencyUri))
          } else {
            this._store.dispatch(signOut())
          }
        })
      ),
    { dispatch: false }
  )
}
